<template>
    <div>
        <div v-if="eliPathResultType === 0">
            <h2>Изаберите врсту гласила</h2>
        </div>
        <div v-if="eliPathResultType === 1">
            <h2>Изаберите годину</h2>
        </div> 
        <div v-if="eliPathResultType === 2">
            <h2>Изаберите број гласила</h2>
        </div> 
        <div v-if="eliPathResultType === 3">
            <h2>Изаберите акт</h2>
        </div>
        
        <ul>
            <li v-for="(item, index) in eliPathResultInfo" v-bind:key="index">
                    <a  :href="item.url">{{ item.name }}</a>
                </li>
        </ul>
    </div>
</template>

<script>
    export default {
    name: "EliComponent",
    props: [
        'eliPathResultType',
        'eliPathResultInfo',
    ],
}
</script>

<style scoped>
ul {
    margin-left: 25px;
    list-style-type: none;
}
h2 {
    margin-left: 10px;
}
</style>